import React from "react";
import { Card, Button } from "react-bootstrap";
import { FaGoogle, FaUnlink, FaFacebook } from "react-icons/fa";

const LinkedAccountsCard = ({
  user,
  onLinkGoogle,
  onUnlinkGoogle,
  onLinkFacebook,
  onUnlinkFacebook,
}) => {
  return (
    <Card className="shadow-sm mt-4">
      <Card.Header className="bg-light py-3">
        <Card.Title as="h5" className="mb-0">
          Linked Accounts
        </Card.Title>
      </Card.Header>
      <Card.Body>
        {/* Google Section */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <FaGoogle className="me-2 text-danger" size="1.2em" />
            <span className="fw-bold">Google</span>
          </div>
          {user?.isGoogleLinked ? (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={onUnlinkGoogle}
            >
              <FaUnlink className="me-1" /> Unlink
            </Button>
          ) : (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={onLinkGoogle}
            >
              <FaGoogle className="me-1" /> Link
            </Button>
          )}
        </div>
        <small className="text-muted d-block mb-3">
          {user?.isGoogleLinked
            ? `Linked with: ${user.googleLinkedEmail || "Google Account"}`
            : "Link your Google account for an alternative sign-in method."}
        </small>

        {/* Facebook Section */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center">
            <FaFacebook className="me-2 text-primary" size="1.2em" />
            <span className="fw-bold">Facebook</span>
          </div>
          {user?.isFacebookLinked ? (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={onUnlinkFacebook}
              disabled
            >
              <FaUnlink className="me-1" /> Unlink (Soon)
            </Button>
          ) : (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={onLinkFacebook}
              disabled
            >
              <FaFacebook className="me-1" /> Link (Soon)
            </Button>
          )}
        </div>
        <small className="text-muted d-block">
          {user?.isFacebookLinked
            ? `Linked with: ${user.facebookLinkedEmail || "Facebook Account"}`
            : "Link your Facebook account for an alternative sign-in method."}
        </small>
      </Card.Body>
    </Card>
  );
};

export default LinkedAccountsCard;
